import * as Yup from "yup";

export const treatmentHistorySchema = Yup.object().shape({
  // require ECOG status (API expects a value like "ECOG 1" or "Unknown")
//   ecog_status: Yup.string().required("ECOG status is required"),

//   // dates should be strings in YYYY-MM-DD (HTML date input)
//   date_of_start: Yup.string().required("Start date is required"),
//   date_of_end: Yup.string().nullable(),

//   // keep other validation lightweight; you can tighten if needed
//   intention_of_treatment: Yup.string().nullable(),
//   role_of_treatment: Yup.string().nullable(),
//   details: Yup.string().nullable(),
//   status_of_treatment: Yup.string().nullable(),

//   // Surgery (optional)
//   date_of_surgery: Yup.string().nullable(),
//   primary_site: Yup.string().nullable(),
//   surgical_procedure_performed: Yup.string().nullable(),
//   surgeon_name: Yup.string().nullable(),
//   extent_of_resection: Yup.string().nullable(),
//   tumor_margins: Yup.string().nullable(),
//   lymph_node_dissection: Yup.string().nullable(),

//   // Chemo / Radio / Targeted / Immuno / Hormone - all nullable for now
//   chemo_regimen: Yup.string().nullable(),
//   chemo_protocol_with_duration: Yup.string().nullable(),
//   chemo_planned_cycles: Yup.string().nullable(),
//   chemo_cycles_administered: Yup.string().nullable(),

//   radiotherapy_regimen: Yup.string().nullable(),
//   radiotherapy_protocol_name: Yup.string().nullable(),
//   radiotherapy_treatment_intent: Yup.string().nullable(),
//   radiotherapy_total_dose: Yup.string().nullable(),
//   radiotherapy_dose_per_fraction: Yup.string().nullable(),
//   radiotherapy_no_of_planned_fractions: Yup.string().nullable(),
//   radiotherapy_no_of_fractions_administered: Yup.string().nullable(),
//   radiotherapy_treatment_site: Yup.string().nullable(),
//   radiotherapy_radiation_modality: Yup.string().nullable(),

//   targeted_therapy_regimen_protocol: Yup.string().nullable(),
//   targeted_therapy_treatment_intent: Yup.string().nullable(),
//   targeted_therapy_targeted_drug: Yup.string().nullable(),
//   targeted_therapy_molecular_target: Yup.string().nullable(),
//   targeted_therapy_specific_dose: Yup.string().nullable(),
//   targeted_therapy_route_of_administration: Yup.string().nullable(),
//   targeted_therapy_planned_cycles: Yup.string().nullable(),
//   targeted_therapy_administered_cycles: Yup.string().nullable(),

//   immunotherapy_regimen: Yup.string().nullable(),
//   immunotherapy_protocol_name: Yup.string().nullable(),
//   immunotherapy_treatment_intent: Yup.string().nullable(),
//   immunotherapy_targeted_drug: Yup.string().nullable(),
//   immunotherapy_molecular_target: Yup.string().nullable(),
//   immunotherapy_specific_dose: Yup.string().nullable(),
//   immunotherapy_route_of_administration: Yup.string().nullable(),
//   immunotherapy_planned_cycles: Yup.string().nullable(),
//   immunotherapy_administered_cycles: Yup.string().nullable(),

//   hormone_therapy_regimen_protocol: Yup.string().nullable(),
//   hormone_therapy_treatment_intent: Yup.string().nullable(),
//   hormone_therapy_immunotherapy: Yup.string().nullable(),
//   hormone_therapy_mechanism_of_action: Yup.string().nullable(),
//   hormone_therapy_specific_dose: Yup.string().nullable(),
//   hormone_therapy_route_of_administration: Yup.string().nullable(),
//   hormone_therapy_planned_cycles: Yup.string().nullable(),
//   hormone_therapy_cycles_administered: Yup.string().nullable(),
});
